var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrror(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 18.3332C5.39685 18.3332 1.66602 14.6023 1.66602 9.99984C1.66602 5.39734 5.39685 1.6665 9.99935 1.6665C14.6018 1.6665 18.3327 5.39734 18.3327 9.99984C18.3327 14.6023 14.6018 18.3332 9.99935 18.3332ZM9.16852 13.3332L15.0602 7.44067L13.8819 6.26234L9.16852 10.9765L6.81102 8.619L5.63268 9.79734L9.16852 13.3332Z",
    fill: "#F9123B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 9.5,
    rx: 7,
    ry: 6.5,
    fill: "#F9123B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1716 7.48505L10 9.65663M7.82843 11.8282L10 9.65663M10 9.65663L12.1716 11.8282L7.82843 7.48505",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrror);
export default __webpack_public_path__ + "static/media/errror.5dcc898fffb49300ca1564ca8326b837.svg";
export { ForwardRef as ReactComponent };